module.exports = __webpack_public_path__ + "static/mundo-7ca2ca89a71e2ce9497f740059a75e23.png";